import { createWebHistory, createRouter } from 'vue-router'

const history = createWebHistory()
const router = createRouter({
    history, // 路由模式
    routes: [

        {
            name: 'Index',
            path: '/',
            component: () => import("../views/index/Index.vue"),//首页
            redirect: { name: 'Main'},
            children: [
                {
                    name: 'Main',
                    path: '',
                    component: () => import("../views/index/Main.vue"),//首页
                },
                {
                    name: 'DetailPage',
                    path: '/DetailPage',
                    component: () => import("../views/index/DetailPage.vue"),//详情页
                },
                {
                    name: 'ListPage',
                    path: '/ListPage',
                    component: () => import("../views/index/ListPage.vue"),//列表页
                },

            ]
        },

        {
            name: 'Login',
            path: '/views/members/Login',
            component: () => import("../views/login/Login.vue"),//会员管理登录

        },
        {
            name: 'Manager',
            path: '/Manager',
            component: () => import("../views/members/Manager.vue"),//首页
            meta: {
                needLogin: true //需要加校检判断的路由
            },
            children: [
                {
                    name: 'Unitmembers',
                    path: '/views/members/Unitmembers',
                    component: () => import("../views/members/Unitmembers.vue"),//团队会员申请
                    meta: {
                        needLogin: true //需要加校检判断的路由
                    },
                },
                {
                    name: 'Individualmember',
                    path: '/views/members/Individualmember',
                    component: () => import("../views/members/Individualmember.vue"),//个人会员申请
                    meta: {
                        needLogin: true //需要加校检判断的路由
                    },
                },
                {
                    name: 'AboutUs',
                    path: '/views/members/AboutUs',
                    component: () => import("../views/admin/AboutUs.vue"),//个人信息修改
                    meta: {
                        needLogin: true //需要加校检判断的路由
                    },
                },
                {
                    name: 'Password',
                    path: '/views/members/Password',
                    component: () => import("../views/admin/Password.vue"),//密码修改
                    meta: {
                        needLogin: true //需要加校检判断的路由
                    },
                },
                {
                    name: 'Notice',
                    path: '/views/members/Notice',
                    component: () => import("../views/admin/Notice.vue"),//密码修改
                    meta: {
                        needLogin: true //需要加校检判断的路由
                    },
                },
                {
                    name: 'Application',
                    path: '/views/members/Application',
                    component: () => import("../views/members/Application.vue"),//申请状态查询
                    meta: {
                        needLogin: true //需要加校检判断的路由
                    },
                },
                {
                    name: 'Sportentries',
                    path: '/views/members/Sportentries',
                    component: () => import("../views/members/Sportentries.vue"),//生物竞赛报名查询
                    meta: {
                        needLogin: true //需要加校检判断的路由
                    },
                },
                {
                    name: 'ApplyList',
                    path: '/views/members/ApplyList',
                    component: () => import("../views/members/ApplyList.vue"),//生物竞赛报名列表查询
                    meta: {
                        needLogin: true //需要加校检判断的路由
                    },
                },
            ]
        },
        {
            name: 'Apply',
            path: '/views/members/Apply',
            component: () => import("../views/members/Apply.vue"),//生物竞赛报名首页
            meta: {
                needLogin: true //需要加校检判断的路由
            },
        },




    ]
})
//  导航守卫
router.beforeEach((to, from, next) => {
    if (to.name !== 'Login') {
        if (to.meta.needLogin) {

            let token = localStorage.getItem('shareui_token');
            if (token) {
                next()
            } else {
                next({ name: 'Login' })
            }
        } else {
            
            next()
            
        }
    } else {
        next()
    }
})


export default router
